export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  tags: string[];
  imageUrl: string;
  author: string;
  publishDate: string;
  readCount: number;
  likeCount: number;
  isHot: boolean;
  isTrending: boolean;
}

export const articles: Article[] = [
  {
    id: "1",
    title: "某千万粉丝网红深夜直播翻车，人设崩塌全过程曝光",
    slug: "qianwan-fensi-wanghong-zhibo-fanche",
    excerpt: "拥有超过两千万粉丝的知名网红在最新一场直播中发生严重翻车事件，现场言论引发巨大争议，相关话题迅速登上热搜榜首。",
    content: `<p>近日，一场原本平常的直播，却意外成为了今年最大的网红翻车事件之一。拥有超过两千万粉丝的头部网红"小七"，在直播间与粉丝互动时，因被追问此前承诺的公益活动进展，情绪失控发表了不当言论。</p><p>事件发生后的短短两小时内，相关话题阅读量突破5亿，#小七翻车# 话题持续霸榜。大量粉丝表示失望，部分品牌方也开始紧急撤下与其相关的合作内容。</p><p>据知情人士透露，该网红此前承诺的多个公益项目均未实际落地，所谓的"捐款"也缺乏有效的凭证支持。这一系列行为被网友称为"教科书级别的虚假人设"。</p><p>目前，该网红的所有社交账号评论区已经关闭，其所属MCN机构发布声明表示将"严肃处理此事"。业内分析人士认为，这次事件将对整个网红行业产生深远影响，或将推动更严格的行业规范出台。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    tags: ["网红翻车", "直播间", "人设崩塌", "虚假公益"],
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20live%20streaming%20studio%20scene%20with%20bright%20ring%20light%20and%20empty%20chair%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20lighting%2C%20tense%20mood%2C%20modern%20tech%20equipment%20visible%2C%20editorial%20photography%20style%20with%20high%20contrast&width=800&height=500&seq=article-wanghong-001&orientation=landscape",
    author: "吃瓜小编",
    publishDate: "2026-07-06",
    readCount: 128900,
    likeCount: 34500,
    isHot: true,
    isTrending: true,
  },
  {
    id: "2",
    title: "顶流男星被曝隐婚生子，工作室紧急发律师函",
    slug: "dingliu-nanxing-yinhun-shengzi",
    excerpt: "据多方消息源证实，某顶流男星已秘密结婚并育有一子，消息曝光后粉丝圈震动，工作室迅速回应并发出律师函维权。",
    content: `<p>昨晚，知名娱记在社交平台爆出重磅消息，称某位当红顶流男星早已秘密结婚，并且育有一名三岁的孩子。消息一出，立刻在网络上引发轩然大波。</p><p>该男星一直以来都以"单身贵族"的形象示人，此前也多次在公开场合表示自己"专注于事业，暂时没有恋爱计划"。这次的爆料直接推翻了其多年经营的人设。</p><p>事件发酵后，该男星的工作室在凌晨紧急发布声明，否认隐婚传闻，并表示将通过法律途径追究造谣者的责任。然而，有网友发现工作室并未正面回应"是否有孩子"的问题，这引发了更多猜测。</p><p>值得注意的是，在此次爆料之前，已经有多位圈内人士暗示过该男星的婚姻状况，但均未引起太大关注。此次事件的发生，也被认为是多个"知情人士"长期积累线索后的集中爆发。</p>`,
    category: "明星爆料",
    categorySlug: "mingxing-baoliao",
    tags: ["男星", "隐婚", "律师函", "工作室回应"],
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20scene%20with%20spotlight%20and%20empty%20stage%2C%20blurred%20paparazzi%20cameras%20in%20background%2C%20mysterious%20atmosphere%2C%20deep%20shadows%20and%20bright%20highlights%2C%20cinematic%20noir%20style%2C%20glamorous%20yet%20tense%20mood&width=800&height=500&seq=article-mingxing-002&orientation=landscape",
    author: "八卦猎人",
    publishDate: "2026-07-06",
    readCount: 256700,
    likeCount: 89200,
    isHot: true,
    isTrending: true,
  },
  {
    id: "3",
    title: "知名带货主播涉虚假宣传被立案调查，直播间商品全部下架",
    slug: "daihuo-zhubo-xujia-xuanchuan",
    excerpt: "头部带货主播因涉嫌虚假宣传被市场监管部门立案调查，其直播间所有商品紧急下架，消费者维权群一夜之间涌入数万人。",
    content: `<p>今日上午，市场监督管理部门正式宣布，对某知名带货主播涉嫌虚假宣传的行为进行立案调查。这是今年以来，监管部门对直播带货行业开出的最严厉的一次"警示"。</p><p>据悉，该主播在近期的一场直播中，宣称某款美容仪具有"医疗级"功效，能够"根治"多种皮肤问题。然而，经消费者投诉和专业机构检测，该产品仅为普通家用美容仪，不具备任何医疗功效。</p><p>事件曝光后，该主播团队紧急将所有在售商品下架，直播间也暂时关闭。但其社交平台评论区已经涌入大量维权消费者，要求退货退款并赔偿损失。</p><p>业内人士指出，直播带货行业的监管正在日趋严格，此次事件可能成为行业整顿的标志性案例。多个平台也表示将加强对带货主播的资质审核和内容监管。</p>`,
    category: "每日吃瓜",
    categorySlug: "meiri-chigua",
    tags: ["带货主播", "虚假宣传", "立案调查", "消费者维权"],
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20live%20streaming%20studio%20with%20empty%20product%20display%20table%2C%20darkened%20room%20with%20studio%20lights%20turned%20off%2C%20abandoned%20shopping%20cart%20silhouette%2C%20dramatic%20lighting%20with%20deep%20contrast%2C%20editorial%20photography%2C%20moody%20corporate%20atmosphere&width=800&height=500&seq=article-daihuo-003&orientation=landscape",
    author: "消费观察员",
    publishDate: "2026-07-05",
    readCount: 187400,
    likeCount: 56300,
    isHot: true,
    isTrending: false,
  },
  {
    id: "4",
    title: "某女星综艺录制现场与导演爆发激烈冲突，节目组宣布暂停拍摄",
    slug: "nvxing-zongyi-chongtu-daoyan",
    excerpt: "热门综艺录制现场突发状况，某女星因节目安排问题与导演组发生激烈争执，导致拍摄中断，目前节目组已发布官方声明。",
    content: `<p>据现场工作人员透露，在昨日某热门综艺的录制过程中，一位参与录制的女星因不满节目组对其镜头的"恶意剪辑"，在休息期间与导演发生了激烈争吵。</p><p>目击者称，争吵持续了将近二十分钟，现场气氛一度非常紧张。该女星指责节目组"故意制造矛盾"来博取收视率，而导演则回应称"一切都是按照台本执行"。</p><p>事件发生后，节目组立即宣布暂停当天的拍摄工作。官方随后发布声明表示，将重新调整节目内容安排，并确保所有参与嘉宾的权益得到保障。</p><p>这一事件也引发了公众对综艺节目"剧本化"现象的热议。不少网友表示，近年来各大综艺过度追求话题度和冲突感，已经严重偏离了"真实"的初衷。</p>`,
    category: "明星爆料",
    categorySlug: "mingxing-baoliao",
    tags: ["女星", "综艺", "冲突", "节目组"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20seats%2C%20dramatic%20shadows%20across%20the%20floor%2C%20abandoned%20camera%20equipment%2C%20tense%20backstage%20atmosphere%2C%20cinematic%20lighting%2C%20high%20contrast%20editorial%20photography&width=800&height=500&seq=article-zongyi-004&orientation=landscape",
    author: "综艺前线",
    publishDate: "2026-07-05",
    readCount: 213600,
    likeCount: 78100,
    isHot: true,
    isTrending: false,
  },
  {
    id: "5",
    title: "百万粉美食博主被扒出假吃，呕吐镜头意外曝光",
    slug: "meishi-bozhu-jiachi-puguang",
    excerpt: "拥有数百万粉丝的美食博主被眼尖网友发现假吃证据，一段疑似其在后台呕吐的偷拍视频在网络上疯传，引发全网红争议。",
    content: `<p>这几天，美食圈最大的瓜莫过于某百万粉丝美食博主的"假吃"风波了。事情的起因是有网友发现，该博主在视频中虽然展示了大量食物，但咀嚼和吞咽的镜头总是被巧妙剪掉。</p><p>更致命的是，一段据称是该博主在拍摄间隙去洗手间呕吐的视频被曝光。视频虽然画质模糊，但多名粉丝通过衣着和体型确认了其身份。</p><p>面对质疑，该博主发布长文道歉，承认自己"确实使用了一些剪辑手法来提升视频效果"，但否认故意欺骗观众。然而，这个解释并未获得大多数网友的认可。</p><p>目前，该博主的多个品牌合作已经被暂停，其视频播放量也出现了断崖式下跌。有MCN机构内部人士透露，这起事件可能使其面临高达数百万的违约金赔偿。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    tags: ["美食博主", "假吃", "视频曝光", "品牌解约"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20restaurant%20table%20with%20half-eaten%20food%20plates%2C%20dim%20ambient%20lighting%2C%20abandoned%20dining%20scene%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20warm%20dark%20tones%2C%20editorial%20food%20photography%20style&width=800&height=500&seq=article-meishi-005&orientation=landscape",
    author: "打假先锋",
    publishDate: "2026-07-04",
    readCount: 342100,
    likeCount: 125400,
    isHot: false,
    isTrending: true,
  },
  {
    id: "6",
    title: "rapper歌手被前女友实锤出轨，聊天记录不堪入目",
    slug: "rapper-chugui-liaotian-jilu",
    excerpt: "某知名说唱歌手被前女友在社交平台发长文实锤出轨，曝光的聊天记录内容露骨，多位圈内人士被卷入其中。",
    content: `<p>昨晚深夜，一位自称是某知名rapper前女友的网友，在社交平台发布了长达三千字的长文，详细描述了两人交往期间该rapper的多次出轨行为。</p><p>随文曝光的还有数十张聊天截图，内容涉及该rapper与多名女性的暧昧对话。部分聊天记录显示，出轨行为甚至发生在其参加某音乐节演出期间。</p><p>更让人震惊的是，聊天记录中疑似还涉及到了其他几位知名rapper的"共同行为"。这导致整个说唱圈都陷入了舆论漩涡，多位歌手紧急发布声明撇清关系。</p><p>截至目前，该rapper本人尚未对此事做出任何回应。但其所属厂牌已经取消了原定于下周的新专辑发布会。圈内人士分析，这次事件将对其职业生涯造成重大打击。</p>`,
    category: "每日吃瓜",
    categorySlug: "meiri-chigua",
    tags: ["rapper", "出轨", "聊天记录", "说唱圈"],
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20recording%20studio%20with%20microphone%20stand%20and%20empty%20chair%2C%20moody%20purple%20and%20red%20ambient%20lighting%2C%20abandoned%20headphones%20on%20mixing%20console%2C%20dramatic%20shadows%2C%20urban%20music%20atmosphere%2C%20cinematic%20noir%20style&width=800&height=500&seq=article-rapper-006&orientation=landscape",
    author: "说唱圈八卦",
    publishDate: "2026-07-04",
    readCount: 198500,
    likeCount: 67200,
    isHot: false,
    isTrending: true,
  },
  {
    id: "7",
    title: "某知名导演被多名女演员联合举报，涉嫌利用职务之便诱导新人",
    slug: "zhiming-daoyan-bei-jubao",
    excerpt: "五位女演员联合向行业协会提交实名举报信，指控某知名导演在选角过程中存在不当行为，事件引发影视圈大地震。",
    content: `<p>今日下午，五位女演员通过律师向影视行业协会联合提交了实名举报信，指控某位在圈内颇有声望的导演，在选角过程中利用职务之便，对多名新人女演员进行了不当诱导。</p><p>举报信中详细列举了多起具体事件，时间跨度从2019年至2025年，涉及至少八位新人演员。五位举报人表示，她们是"为了后来者不再受害"而选择站出来。</p><p>事件曝光后，多家与该导演有合作关系的影视公司紧急发布声明，表示将暂停所有合作项目，等待调查结果。该导演参与制作的几部待播影视剧也可能因此面临延期。</p><p>行业协会回应称，已经正式受理此举报，将成立专项调查组进行深入调查。这起事件也被认为是国内影视行业#MeToo运动的一个重要里程碑。</p>`,
    category: "明星爆料",
    categorySlug: "mingxing-baoliao",
    tags: ["导演", "举报", "影视圈", "行业整顿"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20film%20director%20chair%20on%20dark%20movie%20set%20with%20spotlight%2C%20abandoned%20clapperboard%20on%20ground%2C%20dramatic%20single%20light%20source%2C%20cinematic%20atmosphere%2C%20tense%20mood%2C%20high%20contrast%20black%20and%20white%20style&width=800&height=500&seq=article-daoyan-007&orientation=landscape",
    author: "影视观察",
    publishDate: "2026-07-03",
    readCount: 451200,
    likeCount: 167800,
    isHot: false,
    isTrending: false,
  },
  {
    id: "8",
    title: "电竞圈顶流选手突然宣布退役，背后真相竟是内部矛盾",
    slug: "dianjing-xuanshou-tuiyi-neimu",
    excerpt: "年仅22岁的电竞顶流选手突然发布退役声明，引发粉丝哗然。知情人曝退役真相为与战队管理层存在不可调和的矛盾。",
    content: `<p>昨日晚间，电竞圈发生了一件让所有人始料未及的大事——某项目世界冠军级别的顶流选手在社交平台发布了退役声明，宣布即日起退出职业赛场。</p><p>这位年仅22岁的选手正值职业生涯黄金期，其突然退役的决定让无数粉丝难以置信。在声明中，该选手仅以"个人原因"作为解释，未透露更多细节。</p><p>然而，多位电竞圈内部人士随后爆料称，退役的真实原因是该选手与战队管理层在合同续约和赛事安排上存在严重分歧。据悉，管理层希望选手减少个人直播时间，专注于战队训练，而选手则认为现有合同价值严重被低估。</p><p>此事件也让电竞行业的选手权益问题再次受到关注。有评论指出，随着电竞产业规模的不断扩大，选手与俱乐部之间的劳资关系亟待更规范的制度保障。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    tags: ["电竞", "退役", "内部矛盾", "选手权益"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20esports%20arena%20with%20gaming%20chairs%20and%20darkened%20LED%20screens%2C%20dramatic%20stage%20lighting%2C%20abandoned%20gaming%20keyboard%20and%20mouse%2C%20cold%20blue%20ambient%20glow%2C%20cinematic%20atmosphere%2C%20futuristic%20venue&width=800&height=500&seq=article-esports-008&orientation=landscape",
    author: "电竞前线",
    publishDate: "2026-07-03",
    readCount: 189300,
    likeCount: 54300,
    isHot: false,
    isTrending: false,
  },
  {
    id: "9",
    title: "某品牌代言人翻车，品牌方连夜发声明切割",
    slug: "pinpai-daiyanren-fanche",
    excerpt: "某知名品牌代言人因个人言行问题陷入舆论风波，品牌方在事发后3小时内紧急发布声明终止合作，创下品牌解约最快纪录。",
    content: `<p>如果说有什么比艺人翻车更让人唏嘘的，那一定是品牌方的"光速解约"。就在昨天，某国际知名品牌用3小时创下了品牌解约的最快纪录。</p><p>事件起因是品牌代言人在一个私人聚会上发表了不当言论，相关视频被在场人士偷拍并上传网络。虽然视频很快被删除，但已经引发了大量网友的声讨。</p><p>品牌方反应极其迅速，在事件发生不到3小时后就通过官方渠道发布声明，宣布"即日起终止与该艺人的所有合作关系"。这一速度被网友戏称为"闪电战"。</p><p>据悉，该代言合同原本还有两年才到期，品牌方此次宁愿支付违约金也要迅速切割，可见此次事件的严重程度。这一案例也给其他品牌和代言人敲响了警钟。</p>`,
    category: "每日吃瓜",
    categorySlug: "meiri-chigua",
    tags: ["品牌代言", "解约", "不当言论", "危机公关"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20billboard%20with%20torn%20advertisement%20poster%20in%20urban%20street%2C%20night%20scene%20with%20city%20lights%2C%20dramatic%20atmosphere%2C%20modern%20commercial%20district%2C%20cinematic%20composition%2C%20moody%20urban%20photography&width=800&height=500&seq=article-pinpai-009&orientation=landscape",
    author: "品牌观察",
    publishDate: "2026-07-02",
    readCount: 167200,
    likeCount: 48900,
    isHot: false,
    isTrending: false,
  },
  {
    id: "10",
    title: "网传某男团成员涉嫌抄袭海外歌曲，制作人发声澄清",
    slug: "nantuan-chengyuan-chaoxi",
    excerpt: "某人气男团最新单曲被指与海外某小众乐队的歌曲旋律高度相似，制作人紧急发文附上创作时间线以证清白。",
    content: `<p>近日，某人气男团刚刚发布的最新单曲陷入了抄袭争议。有海外网友指出，这首歌的副歌部分旋律与一支独立乐队的歌曲几乎一模一样。</p><p>事件爆发后，粉丝和网友迅速分成了两派。一边是粉丝力挺偶像，称"这只是巧合"；另一边则是音乐爱好者制作了详细的对比视频，逐段指出相似之处。</p><p>面对质疑，负责这首歌曲的制作人在凌晨紧急发文，晒出了完整的创作时间线和工程文件截图，力证歌曲为原创作品。他表示，创作过程中确实参考了一些经典风格，但绝不存在抄袭行为。</p><p>目前，事件仍在持续发酵中。多位音乐人也参与到了讨论中，有人认为"相似不能等同于抄袭"，但也有人指出"如此高的相似度确实不太可能是巧合"。这场争论也引发了公众对音乐创作边界的热议。</p>`,
    category: "精选内容",
    categorySlug: "jingxuan-neirong",
    tags: ["男团", "抄袭争议", "制作人", "音乐创作"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20music%20recording%20studio%20with%20sheet%20music%20on%20stand%2C%20dim%20ambient%20lighting%2C%20abandoned%20instruments%2C%20moody%20creative%20atmosphere%2C%20cinematic%20composition%2C%20warm%20dark%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-nantuan-010&orientation=landscape",
    author: "音乐圈内人",
    publishDate: "2026-07-02",
    readCount: 134600,
    likeCount: 41200,
    isHot: false,
    isTrending: false,
  },
  {
    id: "11",
    title: "短视频平台网红互撕升级，双方粉丝线下约架被警方制止",
    slug: "wanghong-husi-xianshi-yuejia",
    excerpt: "两位百万粉丝网红在网络上的互撕愈演愈烈，双方极端粉丝竟在线下组织约架，最终被警方及时介入阻止。",
    content: `<p>网红之间的"口水战"我们见多了，但发展到粉丝线下约架的地步，还是让人大跌眼镜。近日，两位拥有数百万粉丝的短视频创作者因为在直播中的几句口角，引发了一场持续数日的网络大战。</p><p>随着事态不断升级，双方的部分极端粉丝开始在社交群组中组织线下见面"讨说法"。据警方通报，7月1日晚间，约四十余名双方粉丝在一处公园聚集，所幸警方接到线索后及时赶到，制止了可能的冲突。</p><p>事件发生后，平台方对两位涉事网红的账号进行了不同程度的处罚，包括限制直播功能和降低内容推荐权重。当地警方也对组织者进行了批评教育。</p><p>这起事件引发了公众对网红"饭圈化"现象的担忧。有社会学者指出，当网红的粉丝也开始模仿饭圈的极端行为时，说明整个网络内容生态需要进行更加深刻的反思和调整。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    tags: ["网红互撕", "粉丝约架", "警方介入", "饭圈化"],
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20urban%20park%20at%20night%20with%20police%20car%20lights%20reflecting%2C%20abandoned%20gathering%20scene%2C%20dramatic%20blue%20and%20red%20emergency%20lights%2C%20tense%20atmosphere%2C%20cinematic%20street%20photography%2C%20moody%20night%20scene&width=800&height=500&seq=article-husi-011&orientation=landscape",
    author: "网络观察",
    publishDate: "2026-07-01",
    readCount: 276400,
    likeCount: 93400,
    isHot: false,
    isTrending: false,
  },
  {
    id: "12",
    title: "数据造假产业链被央视曝光，多位网红数据注水超90%",
    slug: "shuju-zaojia-yangshi-baoguang",
    excerpt: "央视315特别节目揭露网红数据造假黑色产业链，经第三方机构检测，多位头部网红的真实粉丝互动率不足其显示数据的10%。",
    content: `<p>在刚刚播出的央视315特别节目中，一条关于网红数据造假的暗访调查引发了全网轰动。节目揭露了一条从刷量软件开发商到中间商再到网红MCN机构的完整造假产业链。</p><p>根据第三方检测机构的数据，多位被检测的头部网红中，最严重的一位其真实粉丝互动率仅为显示数据的3.7%。这意味着，该网红980万的粉丝中，真实活跃粉丝可能不足50万。</p><p>节目还揭露了"僵尸粉"、"机器评论"、"虚假直播间人气"等多种造假手段。其中最令人震惊的是一种可以根据直播内容自动生成"真实感评论"的AI系统，每条评论收费0.5元。</p><p>节目播出后，多个平台表示将升级反作弊系统，加强对数据的监测。市场监管部门也表示，将把网红数据造假纳入不正当竞争行为的整治范围。</p>`,
    category: "精选内容",
    categorySlug: "jingxuan-neirong",
    tags: ["数据造假", "央视曝光", "黑色产业链", "行业乱象"],
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20LED%20lights%2C%20rows%20of%20computer%20racks%2C%20mysterious%20data%20center%20atmosphere%2C%20red%20warning%20indicators%2C%20cinematic%20tech%20noir%20style%2C%20dramatic%20lighting%2C%20cyber%20mood&width=800&height=500&seq=article-shuju-012&orientation=landscape",
    author: "行业深喉",
    publishDate: "2026-06-30",
    readCount: 523800,
    likeCount: 201400,
    isHot: false,
    isTrending: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.categorySlug === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((article) => article.isHot);
};

export const getTrendingArticles = (): Article[] => {
  return articles.filter((article) => article.isTrending);
};

export const getRelatedArticles = (article: Article, count: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id)
    .filter((a) => a.categorySlug === article.categorySlug || a.tags.some((t) => article.tags.includes(t)))
    .slice(0, count);
};

export const getLatestArticles = (count: number = 8): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
};